(function(document, window, $) {
    'use strict';

    var slidePanelHistory = [];

    window.App = Site.extend({
        changeGetParameter: function (url, paramName, paramValue) {
            if (url.indexOf(paramName + "=") >= 0) {
                var prefix = url.substring(0, url.indexOf(paramName));
                var suffix = url.substring(url.indexOf(paramName));
                suffix = suffix.substring(suffix.indexOf("=") + 1);
                suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
                url = prefix + paramName + "=" + paramValue + suffix;
            }
            else {
                if (url.indexOf("?") < 0)
                    url += "?" + paramName + "=" + paramValue;
                else
                    url += "&" + paramName + "=" + paramValue;
            }

            return url;
        },
        handleSlidePanel: function() {

            if (typeof $.slidePanel === 'undefined') return;

            var defaults = $.components.getDefaults("slidePanel");
            var options = window.PanelOptions = $.extend({}, defaults, {
                template: function(options) {
                    return '<div class="' + options.classes.base + ' ' + options.classes.base + '-' + options.direction + '">' +
                        '<div class="' + options.classes.base + '-scrollable"><div>' +
                        '<div class="' + options.classes.content + '"></div>' +
                        '</div></div>' +
                        '<div class="' + options.classes.base + '-handler"></div>' +
                        '</div>';
                },
                afterLoad: function() {

                    this.$panel.find('.' + this.options.classes.base + '-scrollable').asScrollable({
                        namespace: 'scrollable',
                        contentSelector: '>',
                        containerSelector: '>'
                    });
                    window.hadleSlideHistory();
                    window.initSlidePanel(this.$panel);
                    window.slideopen = true;

                },

                afterHide: function() {
                    window.clearSlideHistory();
                    $('.tooltip').hide();
                    window.slideopen = false;
                }
            });

            $(document).on('click', '[data-toggle=slidePanel]', function(e) {
                window.removeTooltips();
                var url =  $(this).data('url');
                window.addToSlideHistory(url);


                openSlide(url);

                e.stopPropagation();
                e.preventDefault();
                if ($(this).hasClass('model-item')) {
                    $('.model-item.active-item-slidepanel').removeClass('active-item-slidepanel');
                    $(this).addClass('active-item-slidepanel');
                }
            });

            $(document).on('click', '[data-toggle=slidePanelData]', function(e) {
                window.removeTooltips();

                var url =  $(this).data('url');

                window.addToSlideHistory(url);

                var data = {};
                if ($(this).data('form') != undefined)
                    data = $('#'+$(this).data('form')).serialize();

                $.slidePanel.show({
                    url: $(this).data('url'),
                    postdata: data,
                    settings: {
                        cache: false
                    }
                }, options);

                e.stopPropagation();
                e.preventDefault();
            });


            $(document).on('click', '#slide-back-history', function(e) {
                e.stopPropagation();
                e.preventDefault();
                window.history.back();
                return null;
                var url =  $(this).data('url');
                window.popSlideHistory();
                openSlide(url);

            });

            window.openSlide = function(url){
                $("[data-toggle=dropdown][aria-expanded=true]").dropdown("toggle");
                $.slidePanel.show({
                    url: url,
                    settings: {
                        cache: false
                    }
                }, options);
            }

        },
        handleMultiSelect: function() {
            var $all = $('.select-all');

            $(document).on('change', '.multi-select', function(e, isSelectAll) {

                if (isSelectAll) return;

                var $select = $('.multi-select'),
                    total = $select.length,
                    checked = $select.find('input:checked').length;
                if (total === checked) {
                    $all.find('input').prop('checked', true);
                } else {
                    $all.find('input').prop('checked', false);
                }
            });

            $all.on('change', function() {
                var checked = $(this).find('input').prop('checked');

                $('.multi-select input').each(function() {
                    $(this).prop('checked', checked).trigger('change', [true]);
                });

            });
        },

        handleListActions: function() {
            $(document).on('click', '[data-toggle="list-editable"]', function() {
                var $btn = $(this),
                    $list = $btn.parents('.list-group-item'),
                    $content = $list.find('.list-content'),
                    $editable = $list.find('.list-editable');

                $content.hide();
                $editable.show();
                $editable.find('input:first-child').focus().select();
            });

            $(document).on('keydown', '.list-editable [data-bind]', function(event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);

                if (keycode == 13 || keycode == 27) {
                    var $input = $(this),
                        bind = $input.data('bind'),
                        $list = $input.parents('.list-group-item'),
                        $content = $list.find('.list-content'),
                        $editable = $list.find('.list-editable'),
                        $update = bind ? $list.find(bind) : $list.find('.list-text');

                    if (keycode == 13) {
                        $update.html($input.val());
                    } else {
                        $input.val($update.text());
                    }

                    $content.show();
                    $editable.hide();
                }
            });

            $(document).on('click', '[data-toggle="list-editable-close"]', function() {
                var $btn = $(this),
                    $list = $btn.parents('.list-group-item'),
                    $content = $list.find('.list-content'),
                    $editable = $list.find('.list-editable');

                $content.show();
                $editable.hide();
            });
        },

        run: function(next) {
            this.handleSlidePanel();
            this.handleListActions();
            //this.handleMultiSelect();
            next();
        }
    });

    var hashkey = '#slidepanelopen--';
    var historyIndex = 0;
    var activeSlidepanel = null;

    window.slideurl = null;
    window.slidehash = [];


    $(document).on('click','.site-sidebar-nav [data-toggle="tab"]', function(e){
        //var tab = $(this).attr('href');
        var id =  $(this).attr('id');
         window.hashHistory('tab', id);
    });


    // function locationHashChanged() {
    //     if (location.hash.startsWith(hashkey)){
    //         var parts = location.hash.split('--');
    //        // console.log('Parts');
    //        // console.log(parts);
    //         if (parts[1] != undefined) {
    //          //   console.log('Should open 1');
    //           //  console.log(slidePanelHistory);
    //             var id = parseInt(parts[1])-1;
    //             if (slidePanelHistory.length && slidePanelHistory[id]!= undefined) {
    //             //    console.log('Should open 2');
    //                 if (activeSlidepanel != slidePanelHistory[id])
    //                 openSlide(slidePanelHistory[id]);
    //             }
    //         }
    //     }
    // }

   //this should be back
  //  window.onhashchange = locationHashChanged;


    window.onpopstate = function(event) {

       //console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
        if (event.state != undefined && event.state.slidepanel != undefined){
            openSlide(event.state.slidepanel);
        }else{
            if (window.slideopen) {
                $('.slidePanel-close').trigger('click');
            }
        }
    };


    window.hadleSlideHistory = function(){

        if (slidePanelHistory.length > 1){
            var $backButton = $('#slide-back-history');
            $backButton.attr('data-url', slidePanelHistory[slidePanelHistory.length-2]);
            $backButton.removeClass('hidden');
        }


        var hashObject = history.state;
        if (hashObject.tab != undefined){
            $('#'+hashObject.tab).trigger('click');
        }
    }

    window.addToSlideHistory = function(url){
        slidePanelHistory.push(url);
        activeSlidepanel = url;
        ////this should be back
       // window.location = hashkey+slidePanelHistory.length;
      //  var surl  = hashkey+slidePanelHistory.length;
        var state = window.getHashParts(url);
        state.slidepanel = url;

        history.pushState(state, '', '#'+url);
    }

    window.popSlideHistory = function(){
        slidePanelHistory.pop();
    }


    window.getSlideUrl = function()
    {
        var myurl = slidePanelHistory[slidePanelHistory.length - 1];
        var hashparts = myurl.split("#");
        return hashparts[0];
    }

    window.getHashParts = function(url)
    {
        var params = '';
        var hashparts = url.split("#");

        var searchparts = hashparts[0].split("?");
        if (searchparts.length === 2) var params = searchparts[1]+'&';

        if (hashparts.length === 2) var params = params + hashparts[1] ;

        var urlParams = new URLSearchParams(params);
        //console.log('Haspart:'+hashparts[1]);
        var obj = {};
        urlParams.forEach(function(value, key) {
            obj[key]= value;
        });

       // console.log('Hash parts');
       // console.log(obj);
        return obj;
    }

    // window.getHashArrayOld = function()
    // {
    //     var myurl = slidePanelHistory[slidePanelHistory.length - 1];
    //     var hashparts = myurl.split("#");
    //
    //     if (hashparts.length === 1) return {};
    //
    //     var urlParams = new URLSearchParams(hashparts[1]);
    //     //console.log('Haspart:'+hashparts[1]);
    //     var obj = {};
    //     urlParams.forEach(function(value, key) {
    //         obj[key]= value;
    //     });
    //     return obj;
    // }

    window.hashHistory = function (key, val){
        var state = history.state;
        state[key] = val;
        var myurl =  window.getSlideUrl()+encodeURI('#'+buildQuery(state));
        history.replaceState(state,'');
    }


    // window.hashHistoryOLD = function(key, val){
    //     var slidehash = window.getHashArray();
    //     slidehash[key] = val;
    //
    //     var myurl =  window.getSlideUrl()+'#'+buildQuery(slidehash);
    //     //console.log('hasHistory:'+myurl);
    //     slidePanelHistory.pop();
    //     slidePanelHistory.push(myurl);
    // }

    window.clearSlideHistory = function(){
        //console.log('history clear');
        slidePanelHistory = [];
    }

    var buildQuery = function (data) {
        // If the data is already a string, return it as-is
        if (typeof (data) === 'string') return data;

        // Create a query array to hold the key/value pairs
        var query = [];

        $.each(data, function(key, value) {
            query.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        });

        // Join each item in the array with a `&` and return the resulting string
        return query.join('&');

    };


})(document, window, jQuery);
